// extracted by mini-css-extract-plugin
module.exports = {"container":"block_container__2gG8k","header":"block_header__2ob2v","content":"block_content__A-XQU"};